export default {
  error: "An error has occurred. Please try again or reload the page.",
};
